import { CustomersComponent } from '../../../base-components/customers/customers.component';
import { CustomerDetailsOrisComponent } from './customers-details/customer-details.component';
import { CustomerInfoDetailsOrisComponent } from './customers-details/info/customer-info-details.component';
import { CustomerProductInfoDetailsComponent } from '../../../base-components/customers/customers-details/product/customer-product-info-details.component';

export const CustomersOrisComponents = [
    CustomersComponent,
    CustomerDetailsOrisComponent,
    CustomerInfoDetailsOrisComponent,
    CustomerProductInfoDetailsComponent
];